import { useBreadcrumbTitle } from "@msuite/ui/app-shell";
import type { Nullable, OrganizationMembers } from "@msuite/utils/types";
import { getFullName } from "@msuite/utils/users";
import { useMembers } from "@/hooks/use-members";

/**
 * Name a user's URL segment in the breadcrumbs after the member it belongs to, for the pages whose
 * route carries a user's id without the page reading that user itself.
 *
 * @param userId - The user id the route carries; nothing is read or named without one.
 */
export function useMemberBreadcrumbTitle(userId: Nullable<string>) {
	/** Query */
	const { members } = useMembers(undefined, { enabled: !!userId });

	/** Effects */
	useBreadcrumbTitle(userId, getMemberName(members, userId));
}

/** The member's full name, or `null` while the members are loading or none carries the id. */
function getMemberName(members: OrganizationMembers, userId: Nullable<string>) {
	for (const member of members) {
		if (member.user.id === userId) return getFullName(member.user);
	}
	return null;
}
